import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  getInvoiceById,
  getDownloadInvoiceById,
} from "../../../../services/billing";
import { useBilling } from "../../../../context/BillingContext";
import DescriptionList from "../../../../common/DescriptionList";
import formatDate from "../../../../common/DateFormate";
import { logo } from "../../../../../images";
import { getBrandName } from "../../../StaticPages/Components/getBrandName";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";

const ShowBillingPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [invoice, setInvoice] = useState(null);
  const { id } = useParams();
  const { brandName, mail, phone, address } = getBrandName();
  const { currentPlan } = useBilling();

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        setIsLoading(true);
        const apiRes = await getInvoiceById(id);
        const response = await getDownloadInvoiceById(id);
        setInvoice(apiRes.data.data);
      } catch (err) {
        console.error("Failed fetch perticullar invoice API :", err);
      } finally {
        setIsLoading(false);
      }
    };
    id && fetchInvoice();
  }, [id]);

  const formatAddress = (attr) =>
    [
      attr?.address,
      attr?.address2,
      attr?.district,
      attr?.state,
      attr?.pincode,
      attr?.country,
    ]
      .filter(Boolean)
      .join(", ");

  const formatDate = (date) => {
    if (!date) return "";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate)) return "";

    return parsedDate.toLocaleDateString("en-GB");
  };

  const handleDownloadInvoice = async (invoiceId) => {
    try {
      setIsLoading(true);

      const response = await getDownloadInvoiceById(invoiceId);

      const blob = response.data;

      //  Extract filename from headers
      let fileName = "invoice.pdf";

      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?"?([^"]+)"?/,
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }

      //  Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      // cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleRetryPayment = async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsLoading(false);
    alert("Retry payment triggered!");
  };

  return (
    <>
      <div className="without-datepicker-breadcrumb">
        <Breadcrumb
          categoryName={invoice?.attributes?.invoice_number}
          categoryId={id}
          componentType={"invoiceHistory"}
        />
      </div>
      <section className="container-fluid p-0 mt-2">
        {/* Header */}

        <div className="row g-4">
          {/* Left Content */}
          <div className="col-lg-8">
            {/* Invoice Header Card */}
            <div className="card shadow-sm mb-4">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      {invoice?.attributes?.invoice_number}
                    </h5>
                    {currentPlan?.name && (
                      <p className="card-text text-muted mb-0">
                        {invoice?.attributes?.package_name}
                      </p>
                    )}
                    {/* <div className="col-md-6"> */}
                    {/* <strong>Billing Period:</strong> */}
                    <span>
                      {formatDate(invoice?.attributes?.created_at) || ""} 
                      {/* To{" "}
                      {formatDate(invoice?.attributes?.billed_at) || ""} */}
                    </span>
                    {/* </div> */}
                  </div>
                  <span
                    className={`badge px-3 py-2 fs-6 text-capitalize ${
                      invoice?.attributes?.status === "failed"
                        ? "btn-danger-light"
                        : invoice?.attributes?.status === "issued"
                          ? "payment-status"
                          : "payment-paid"
                    }`}
                  >
                    {invoice?.attributes?.status}
                  </span>
                </div>
                <table className="table table-bordered mt-3">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Amount</th>
                      <th>Tax</th>
                      <th>Total</th>
                    </tr>
                  </thead>

                  <tbody>
                    {invoice?.attributes?.amount ? (
                      <tr>
                        <td>{invoice?.attributes?.package_name}</td>
                        <td>{invoice?.attributes?.amount}</td>
                        <td>{invoice?.attributes?.tax || "0.0"}</td>
                        <td>{invoice?.attributes?.amount}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted">
                          No line items found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* <div className="card-body h-auto row">
                <div className="col-md-4">
                  <strong>Issue Date:</strong>

                  <p>{formatDate(invoice?.attributes?.created_at)||""}</p>

                </div>
                <div className="col-md-4">
                  <strong>Due Date:</strong>
                   <p>{formatDate(invoice?.attributes?.due_at)||""}</p>
                </div>
                {invoice?.attributes?.paid_at && (
                <div className="col-md-4">
                  <strong>Payment Date:</strong>
                  <p>{formatDate(invoice?.attributes?.paid_at)||""}</p>
                </div>
                )}
                <hr />
                <div className="col-md-6">
                  <strong>Billing Period:</strong>
                  <p>

                    {formatDate(invoice?.attributes?.created_at)||""}
                    {" "}To{" "}
                    {formatDate(invoice?.attributes?.billing_end_at)||""}
                  </p>
                </div>
                <div className="col-md-6">
                  <strong>Payment Method:</strong>
                  <p>
                   <span class="text-capitalize">{invoice?.attributes?.payment_method}</span>
                  </p>
                </div>
              </div> */}
            </div>

            {/* Company & Billing Info */}
            <div className="row g-3">
              <div
                className={
                  invoice?.attributes?.address ? "col-md-6" : "col-md-12"
                }
              >
                <div className="card h-100 shadow-sm">
                  <div className="card-header h-auto bg-transparent">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="card-title mb-1 card-title-custom">
                          From
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body h-auto">
                    <h6>
                      {invoice?.attributes?.companyInfo?.name ||
                        brandName + " Private Limited"}
                    </h6>
                    <p className="mb-1">
                      {invoice?.attributes?.companyInfo?.address || address}
                    </p>
                    {/* <p>
                      {invoice?.attributes?.companyInfo?.city}, {invoice?.attributes?.companyInfo?.state}{" "}
                      {invoice?.attributes?.companyInfo?.zip}
                    </p> */}
                    <p>{invoice?.attributes?.companyInfo?.country}</p>
                    <hr />
                    {mail && (
                      <p className="mb-1">
                        <i className="bi bi-envelope"></i>{" "}
                        <a
                          className="text-decoration-none"
                          href={"mailto:" + mail}
                        >
                          {invoice?.attributes?.companyInfo?.email || mail}
                        </a>
                      </p>
                    )}
                    {phone && (
                      <p>
                        <i className="bi bi-telephone"></i>{" "}
                        <a
                          href={"tel:" + phone}
                          className="text-decoration-none"
                        >
                          {invoice?.attributes?.companyInfo?.phone || phone}
                        </a>
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {invoice?.attributes?.address && (
                <div className="col-md-6">
                  <div className="card h-100 shadow-sm">
                    <div className="card-header h-auto bg-transparent">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h5 className="card-title mb-1 card-title-custom">
                            To
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div className="card-body h-auto">
                      <h6 className="text-capitalize">
                        {invoice?.attributes?.name}
                      </h6>
                      {/* <p className="mb-1">
                      {invoice?.attributes?.address}, {invoice?.attributes?.address2||""}, {invoice?.attributes?.district||""}, {invoice?.attributes?.pincode}, {invoice?.attributes?.state}
                    </p> */}
                      <p className="mb-1 text-capitalize">
                        {formatAddress(invoice?.attributes)}
                      </p>
                      <p>
                        {/* {invoice?.attributes?.billingAddress?.city},{" "} */}
                        {/* {invoice?.attributes?.billingAddress?.state} {invoice?.attributes?.billingAddress?.zip} */}
                      </p>
                      {/* <p>{invoice?.attributes?.billingAddress?.country}</p> */}
                      <hr />
                      {invoice?.attributes?.email && (
                        <p className="mb-1">
                          <i className="bi bi-envelope"></i>{" "}
                          <a
                            className="text-decoration-none"
                            href={"mailto:" + invoice?.attributes?.email}
                          >
                            {invoice?.attributes?.email}
                          </a>
                        </p>
                      )}
                      {/* <p className="mb-1"> {invoice?.attributes?.billingAddress?.email}</p> */}
                      {invoice?.attributes?.number && (
                        <p>
                          <i className="bi bi-telephone"></i>{" "}
                          <a
                            href={"tel:" + invoice?.attributes?.number}
                            className="text-decoration-none"
                          >
                            {"+91 " + invoice?.attributes?.number}
                          </a>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Invoice Items */}
            {/* <div className="card shadow-sm">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Invoice Items
                    </h5>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Description</th>
                      <th className="text-center">Qty</th>
                      <th className="text-end">Unit Price</th>
                      <th className="text-end">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice?.attributes?.items.map((item, idx) => (
                      <tr key={idx}>
                        <td className="text-muted">{item?.description}</td>
                        <td className="text-center text-muted">{item?.quantity}</td>
                        <td className="text-end text-muted">${item?.unitPrice}</td>
                        <td className="text-end text-muted fw-bold">${item?.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>*/}
          </div>

          {/* Right Sidebar */}
          <div className="col-lg-4">
            {/* Payment Summary */}
            <div className="card shadow-sm mb-3">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Summary
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card-body h-auto">
                <div className="d-flex justify-content-between">
                  <span>Created Date:</span>
                  <span>
                    {formatDate(invoice?.attributes?.created_at) || ""}
                  </span>
                </div>
                {/* <div className="d-flex justify-content-between">
                  <span>Payment Method:</span>
                  <span>{invoice?.attributes?.payment_method || "-"}</span>
                </div> */}
                <div className="d-flex justify-content-between">
                  <span>Subtotal:</span>
                  <span>{invoice?.attributes?.amount}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Tax:</span>
                  <span>{invoice?.attributes?.tax || "0.0"}</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between fw-bold">
                  <span>Total:</span>
                  <span className="text-color">
                    {invoice?.attributes?.amount}
                  </span>
                </div>
              </div>
            </div>

            {/* Payment Method */}
            {/* <div className="card shadow-sm mb-3">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Payment Method
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card-body h-auto">
                <div className="p-2 border rounded">
                  <p className="mb-1">
                    Card ending in {paymentMethods?.id}
                  </p>
                  <small className="text-muted">
                    Payment {invoice?.attributes?.status}
                  </small>
                </div>
              </div>
            </div> */}

            {/* Actions */}
            <div className="card shadow-sm">
              <div className="card-header h-auto bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1 card-title-custom">
                      Action
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card-body h-auto d-grid gap-2">
                <button
                  className="btn plan-detail-card-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadInvoice(id);
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : " Download PDF"}
                </button>
                {invoice?.attributes?.status === "failed" && (
                  <button
                    className="btn btn-outline-danger"
                    onClick={handleRetryPayment}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "↻ Retry Payment"}
                  </button>
                )}
                {/* <button className="btn btn-light">← Back to Billing</button> */}
                {/* <Link
                  className="btn btn-outline-secondary btn-sm me-3 mb-2"
                  to="/billing-section"
                >
                  {" "}
                  ← Back to Billing
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ShowBillingPage;
